{
  "NTServiceForms": {
    "fields": {
      "otherReasonForAssistance": {
        "neuropsychiatricOrOtherCognitiveImpairment": "Neuropsychiatric or other cognitive impairment"
      }
    }
  }
}
